module.exports = __webpack_public_path__ + "static/luisenstrasse-06a2ccb0e659bc08f34d6c25e6ac15ec.jpg";